import React, { useRef } from 'react'
import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'
import { Input } from '../../..'

const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  appendText: PropTypes.string,
}

const CurrencyInput = React.forwardRef(
  ({ onChange, name, ...restProps }, ref) => {
    const myRef = useRef(null)
    const inputRef = ref || myRef

    return (
      <NumberFormat
        customInput={Input}
        prefix='$'
        getInputRef={inputRef}
        thousandSeparator
        name={name}
        onValueChange={values => {
          const { value } = values

          const event = { target: { name, value } }
          if (onChange) onChange(event)
        }}
        {...restProps}
      />
    )
  }
)

CurrencyInput.propTypes = propTypes
CurrencyInput.displayName = 'CurrencyInput'

export default CurrencyInput
